class CartDrawer extends HTMLElement {
	constructor() {
		super()
		window.FoxTheme = window.FoxTheme || {}
		window.FoxTheme.Cart = this
		this.drawer = this.closest('drawer-component')
		window.FoxTheme.CartDrawer = this.drawer
    this.openWhenAdded = this.dataset.openWhenAdded === 'true'
	}

	connectedCallback() {
    window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async state => {
      this.renderContents(state)
    })
	}

  renderContents(parsedState, renderFooter = true) {
    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer()
        document.body.classList.add('prevent-scroll')
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState)
      }
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
    ]

    if (renderFooter) {
      sections.push({
        id: 'cart-drawer',
        selector: '.f-drawer__footer',
      })
    }

    return sections
  }

}
customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.querySelector('cart-drawer'), { overlay: document.querySelector('cart-drawer') })
  }
  getSectionsToRender() {
    return [
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__block-subtotal',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);






class CartDrawerDiscount extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('[data-cart-discount-form]');
    if (!this.form) return;

    this.input = this.form.querySelector('input[name="discount"]');
    this.error = this.form.querySelector('[data-cart-discount-error]');

    this.form.addEventListener('submit', this.onSubmit);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (!this.form) return;
    this.form.removeEventListener('submit', this.onSubmit);
    this.removeEventListener('click', this.onClick);
  }

  getCartUpdateUrl() {
    const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return `${root}cart/update.js`;
  }

  getExistingDiscounts() {
    return Array.from(this.querySelectorAll('[data-discount-remove]'))
      .map((button) => button.getAttribute('data-discount-remove'))
      .filter(Boolean);
  }

  setError(message) {
    if (!this.error) return;

    if (message) {
      this.error.textContent = message;
      this.error.hidden = false;
    } else {
      this.error.textContent = '';
      this.error.hidden = true;
    }
  }

  async updateDiscounts(discounts) {
    this.setError('');

    const body = JSON.stringify({
      discount: discounts.join(','),
      sections: ['cart-drawer'],
      sections_url: window.location.pathname
    });

    try {
      const response = await fetch(this.getCartUpdateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });

      const parsedState = await response.json();

      if (parsedState.status && parsedState.message) {
        this.setError(parsedState.message);
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && parsedState.sections && parsedState.sections['cart-drawer']) {
        cartDrawer.renderContents(parsedState, true);
      }

      window.FoxThemeEvents.emit('ON_CART_UPDATED', parsedState);
    } catch (error) {
      this.setError('Impossible d’appliquer le code promo.');
      console.error(error);
    }
  }

  async onSubmit(event) {
    event.preventDefault();

    if (!this.input) return;

    const code = this.input.value.trim();
    if (!code) return;

    const existingDiscounts = this.getExistingDiscounts();

    if (existingDiscounts.includes(code)) {
      this.setError('Ce code est déjà appliqué.');
      return;
    }

    await this.updateDiscounts([...existingDiscounts, code]);
  }

  async onClick(event) {
    const removeButton = event.target.closest('[data-discount-remove]');
    if (!removeButton) return;

    event.preventDefault();

    const codeToRemove = removeButton.getAttribute('data-discount-remove');
    if (!codeToRemove) return;

    const existingDiscounts = this.getExistingDiscounts().filter((code) => code !== codeToRemove);

    await this.updateDiscounts(existingDiscounts);
  }
}

customElements.define('cart-drawer-discount', CartDrawerDiscount);